<template>
  <div class="w-full">
    <el-form :model="updateForm" :label-position="labelPosition" :rules="rules" ref="updateForm" v-loading="loading">
      <CustomerForm :form="updateForm" />
      <el-form-item :gutter="20" class="px-5">
        <el-button type="primary" @click="update('updateForm')" :loading="updating">Update</el-button>
        <el-button @click="cancelUpdate" type="info">Close</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

import CustomerForm from './_includes/CustomerForm.vue';

export default {
  name: 'UpdateCustomer',
  components: {
    CustomerForm,
  },
  data() {
    return {
      loading: false,
      updating: false,
      labelPosition: 'top',
      rules: this.$store.state.CustomerModule.validate_form,
    };
  },
  computed: {
    updateForm() {
      return this.$store.state.CustomerModule.customer;
    },
  },
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    try {
      this.loading = true;
      await this.$store.dispatch('CustomerModule/getCustomer', this.$route.params.id);
    } catch (e) {
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    }
    this.loading = false;
  },
  methods: {
    async cancelUpdate() {
      this.$router.back();
    },
    update(updateForm) {
      const formData = {
        first_name: this.updateForm.first_name,
        last_name: this.updateForm.last_name,
        email: this.updateForm.email,
        phone: this.updateForm.phone,
        gender: this.updateForm.gender,
        dob: this.updateForm.dob,
        newsletter: this.updateForm.newsletter,
        verified: this.updateForm.verified,
        suspended: this.updateForm.suspended,
      };
      this.$refs[updateForm].validate(async (valid) => {
        if (valid) {
          try {
            this.updating = true;
            await this.$store.dispatch('CustomerModule/updateCustomer', {
              customerId: this.$route.params.id, customer: formData,
            });
            this.$notify.success({
              title: 'Success',
              message: 'Customer update was successful.',
            });
            this.$router.back();
          } catch (e) {
            this.$notify.error({
              title: 'Error',
              message: 'Something went wrong please try again.',
            });
          }
          this.updating = false;
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
